import { IPrPayslipEntity } from "@odata/GeneratedEntityTypes";
import FormTableList, { IFormTableListSection } from "@pages/payroll/payslip/formTableList/FormTableList";
import { getEditableSections } from "@pages/payroll/payslip/formTableList/FormTableList.utils";
import FormTableListEditDialog from "@pages/payroll/payslip/formTableList/FormTableListEditDialog";
import { IMemoized, memoizeOne } from "@utils/memoizeOne";
import React, { Component } from "react";

import { FormStorage } from "../../../../views/formView/FormStorage";

export interface IOverviewBaseProps {
    storage: FormStorage<IPrPayslipEntity>;
}

interface IState {
    isEditDialogOpen?: boolean;
}

export default abstract class OverviewBase<P extends IOverviewBaseProps = IOverviewBaseProps> extends Component<P, IState> {
    state: IState = {
        isEditDialogOpen: false
    }

    _hasPinkBackground = false;
    _title = "";
    _isEditable = true;
    _minWidth: number = null;
    _hasDynamicColumns = false;

    abstract getSections: IMemoized<[], IFormTableListSection[]>;


    get placeholder(): string {
        return "";
    }

    get showPlaceholder(): boolean {
        return false;
    }

    getEditableSections = memoizeOne(() => {
        return getEditableSections(this.getSections());
    }, () => ([this.getSections()]))

    handleEdit = (): void => {
        this.setState({ isEditDialogOpen: true });
    }

    handleCloseDialog = (): void => {
        this.setState({ isEditDialogOpen: false });
    };

    handleSave = (): void => {
        this.getSections.reset();
        this.handleCloseDialog();
    }

    renderEditDialog(): React.ReactElement {
        return (
                <FormTableListEditDialog sections={this.getEditableSections()}
                                         title={this._title}
                                         storage={this.props.storage}
                                         onCancel={this.handleCloseDialog}
                                         onSave={this.handleSave}/>
        );
    }

    render() {
        return (<>
            <FormTableList sections={this.getSections()}
                           onEdit={this.handleEdit}
                           minWidth={this._minWidth}
                           isEditable={this._isEditable}
                           placeholder={this.showPlaceholder ? this.placeholder : null}
                           hasPinkBackground={this._hasPinkBackground}
                           hasDynamicColumns={this._hasDynamicColumns}/>
            {this.state.isEditDialogOpen && this.renderEditDialog()}
        </>);
    }
}
